module.exports = __webpack_public_path__ + "img/P400.96da7de7.jpg";